// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"53075bf1","16":"cdda1cca","300":"31abb318","453":"127be8e2","597":"2dcd6436","652":"a9ac2323","890":"b770bd01","975":"b6cc238c"}[chunkId] + ".chunk.js";
};